module.exports = __webpack_public_path__ + "static/media/logo-toffee.aa6694c3.png";